import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { breakpoints } from '@avangard/ui/utils';

import { useSchoolSummaryStats } from '@modules/schools/hooks';
import { DashboardWidgetCount } from '@modules/dashboard/organisms';

type SchoolSummaryWidgetsStatsProps = {
    schoolId?: string;
    lapId?: string;
};

const Row = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    grid-gap: 24px;
    margin-bottom: 24px;

    ${breakpoints.down('xs')} {
        grid-gap: 12px;
        margin-bottom: 12px;
    }
`;

const SchoolSummaryWidgetsStats = (props: SchoolSummaryWidgetsStatsProps): React.ReactElement => {
    const { schoolId, lapId } = props;

    const { t } = useTranslation(['schools']);

    const { schoolSummaryStats, loading: isLoading } = useSchoolSummaryStats({
        variables: {
            schoolId: schoolId as string,
            lapId: lapId || undefined,
        },
        skip: !schoolId,
    });

    return (
        <Row>
            <DashboardWidgetCount
                loading={isLoading}
                label={t('schools:widgets.finish_students.title')}
                count={schoolSummaryStats.completed}
            />
            <DashboardWidgetCount
                loading={isLoading}
                label={t('schools:widgets.out_students.title')}
                count={schoolSummaryStats.total - schoolSummaryStats.completed}
            />
            <DashboardWidgetCount
                loading={isLoading}
                label={t('schools:widgets.average_score.title')}
                count={schoolSummaryStats.averageScore}
            />
        </Row>
    );
};

export { SchoolSummaryWidgetsStats };
